var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"careers careers--component"},[_c('CareerResults')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }